import { init } from "./App";

declare global {
  interface Window {
    KISWayChat?: { init: () => void };
  }
}

function mount() {
  let root = document.getElementById("kis-way-chat-root");
  if (!root) {
    root = document.createElement("div");
    root.id = "kis-way-chat-root";
    document.body.appendChild(root);
  }
  if (!root.hasChildNodes()) {
    init();
  }
}

if (typeof window !== "undefined") {
  window.KISWayChat = { init: mount };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mount);
  } else {
    mount();
  }
}
